import React from 'react';
import { FiCpu } from 'react-icons/fi';

/**
 * HardwareChipIcon
 * Ikona čipu pre stavové hlásenia a konektivitu hardvéru.
 */
const HardwareChipIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FiCpu className={className} {...props} />
);

export default HardwareChipIcon;

